import { createPortal } from 'react-dom';
import useLeafletControlContainer from '../hooks/useLeafletControlContainer';

const CustomLeafletControl = ({ position = 'topright', children }) => {
  const containerRef = useLeafletControlContainer(position);

  if (!containerRef.current) {
    return null;
  }

  return createPortal(children, containerRef.current);
};

export default CustomLeafletControl;
